<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" @click.prevent="getUtenti()">{{levelName}}</a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1"><Translate :path="'dizionario.base.ELENCO'"></Translate> {{levelName}}</span>
				</h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10" style="text-align: left;" v-if="$root.hasFunzionalita('UTENTE_CREATE')" v-on:click="nuovoUtente()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">
								<div v-if="livello == 5"><Translate :path="'dizionario.base.BTN_NUOVO'"></Translate> Cliente</div>
								<div v-else><Translate :path="'dizionario.base.BTN_NUOVO'"></Translate>	Admin</div> 							
							</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
						</div>
					</a>

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a v-if="$root.hasFunzionalita((livello == 1 || livello == 2) ? 'CONF_AMMINISTRATORI_READ' : 'CONF_CLIENTI_READ')" v-show="this.modulo != 2" href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="$root.confTravelTipologiche((livello == 1 || livello == 2) ? 21 : 22)" title="Opzioni Utenti" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-lightning"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" @click.prevent="$root.confTravelLingue(livello == 2 ? 21 : 22)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" @click.prevent="$root.help(livello == 2 ? 21 : 22)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#utenti-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list"></i>
								<span class="hidden-lg ms-1">{{levelName}}</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate>{{levelName}}</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation" v-show="livello == 5">
						<a href="#utenti-b" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded" data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1" @click.prevent="statisticheStartup();">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-activity"></i>	
								<span class="hidden-lg ms-1">Stats.</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.BTN_STATISTICHE'"></Translate></span>
							</div>
						</a>
					</li> 
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav" class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed" data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;">Azioni Multiple</span>
								</a>
								<div class="dropdown-menu dropdown-menu-end">
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-ballot-check fa-fw me-2"></i><span class="text-muted me-1">|</span>Stato</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="attivaSelezionati()"><i class="far fa-check-square fa-fw me-2"></i>Attiva selezionati</a>
											<a href="#" class="dropdown-item" @click.prevent="disattivaSelezionati()"><i class="far fa-square fa-fw me-2"></i>Disattiva selezionati</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Comunicazioni</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Invia Email</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Invia SMS</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start" v-if="$root.hasFunzionalita('UTENTE_EXPORT')">
										<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Esporta dati</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('pagina')">
												<i class="far fa-file-export fa-fw me-2"></i>Pagina corrente
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('selezionati')">
												<i class="far fa-file-export fa-fw me-2"></i>
												<span v-if="livello == 5">Utenti selezionati</span><span v-else>Admin selezionati</span>
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('tutti')">
												<i class="far fa-file-export fa-fw me-2"></i>
												<span v-if="livello == 5">Tutti gli Utenti</span><span v-else>Tutti gli Admin</span>
											</a>
										</div>
									</div>
									<div v-show="livello == 5" class="dropdown-divider"></div>
									<a v-show="livello == 5" href="#" class="dropdown-item">
										<i class="far fa-code-merge fa-fw me-2"></i>
										<span class="text-muted me-1">|</span>Merge Utenti
									</a>
									<div class="dropdown-divider" v-show="$root.hasFunzionalita(azioneAdmin)"></div>
									<a href="#" class="dropdown-item" v-show="$root.hasFunzionalita(azioneAdmin)" @click.prevent="eliminaSelezionati()"><i class="far fa-trash fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span>Elimina selezionati</a>
								</div>
							</div>
						</li>
						<li class="nav-item">

						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->	

	</div>
	<!-- /page header -->

	<!-- Content area -->
    <div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade active show" id="utenti-a">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-all" style="">				
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="utente-a">
									<div class="row">
										<div class="col-6 col-md-1 col-lg-1 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Id Utente" v-model="search.ID_UTENTE.VALUE" :tabindex="7" />
										</div>
										<div class="col-6 col-md-1 col-lg-1 mbx-1">
											<select class="form-select form-select-sm" v-model="search.SESSO.VALUE" data-placeholder="Sesso" :tabindex="13">
												<option value="">Sesso </option>   
												<option value="1"> &nbsp; Uomo</option>
												<option value="2"> &nbsp; Donna</option>
											</select>
										</div>
										<div class="col-12 col-md-6 col-lg-6">
											<div class="row">
												<div class="col-6 mbx-1" v-bind:class="{'col-md-3':livello == 5,'col-md-4':livello != 5}">
													<Select2Array v-show="livello != 5" v-model="search.FK_ID_RUOLO.VALUE" :options="$root.arrayRuoliUtente" :filter-fn="checkShowRuolo" placeholder="Ruolo" />
													<select v-show="livello == 5" class="form-select form-select-sm" v-model="search.FK_ID_TIPOLOGIA.VALUE">
														<option value="">Tipologia</option>
														<option v-for="opzione in arrayTipologie" v-bind:value="opzione.ID_OPZIONE_TIPOLOGICA" v-bind:key="opzione.DESCRIZIONE"> &nbsp; {{ opzione.DESCRIZIONE }}</option>
													</select>
												</div> 
												<div class="col-6 mbx-1" v-bind:class="{'col-md-3':livello == 5,'col-md-4':livello != 5}">
													<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Cognome" :tabindex="9" v-model="search.COGNOME.VALUE" />
												</div>
												<div class="mbx-1" v-bind:class="{'col-6 col-md-3':livello == 5,'col-12 col-md-4':livello != 5}">
													<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Email" :tabindex="10" v-model="search.EMAIL.VALUE" />
												</div> 	
												<div v-show="livello == 5" class="col-6 col-md-3 col-lg-3 mbx-1">
													<select class="form-select form-select-sm" id="" data-placeholder="Associazione" :tabindex="4">
														<option value="">Associazione</option>
													</select>
												</div>										
											</div>
										</div>
										<div class="col-6 col-md-1 col-lg-1 mbx-1">
											<select v-show="livello == 5" class="form-select form-select-sm" v-model="search.FK_ID_POSIZIONE.VALUE">
												<option value="">Posizione</option>
												<option v-for="opzione in arrayPosizioni" v-bind:value="opzione.ID_OPZIONE_TIPOLOGICA" v-bind:key="opzione.DESCRIZIONE"> &nbsp; {{ opzione.DESCRIZIONE }}</option>
											</select>
										</div>
										<div v-show="$root.hasFunzionalita(azioneAdmin)" class="col-6 col-md-1 col-lg-1">
											<select class="form-select form-select-sm" v-model="search.FLG_ELIMINATO.VALUE">
												<option value="0">Non elim.</option>
												<option value="">Tutti</option>
												<option value="1">Eliminati</option>
											</select>
										</div>
										<div class="col-6 col-md-1 col-lg-1">
											<select class="form-select form-select-sm" data-placeholder="Stato" v-model="search.STATO.VALUE" :tabindex="13">
												<option value="">Tutti </option>
												<option value="1"> &nbsp; Attivati</option>
												<option value="0"> &nbsp; Disattivati</option>
											</select>
										</div>
										<div class="col-6 col-md-1 col-lg-1">
			                                <a href="#collapse-a" class="btn btn-flat-info btn-sm w-100 collapsed" data-bs-toggle="collapse" @click.prevent="filters.resizeGrid('collapse-a','tableFixHead','box-card')" role="button" aria-expanded="false">
			                                    <div v-if="livello == 5">+ FILTRI</div>
												<div v-else>&nbsp;</div>
											</a>
										</div>
									</div>					   	
									<div class="collapse" id="collapse-a" style="" v-show="livello > 3">
										<div class="row">
											<div class="col-12 col-md-2 col-lg-2 mt-1">
												<Datepicker autocomplete="off" class="bg-light" position="left" style="width:100%" v-model="dataCreazioneRange" @update:model-value="datePickerChangeHandler()"  range multi-calendars   :formats="{ input: 'dd/MM/yyyy HH:mm' }" auto-apply  :partial-range="false" placeholder="Data registrazione" :tabindex="2" />
											</div>  
											<div class="col-6 col-md-2 col-lg-2 mt-1">
												<Select2 :api="'core/geo/stati/select2'" :placeholder="'Nazionalità'" v-model="search.FK_ID_NAZIONALITA.VALUE" :tabindex="16"></Select2>
											</div>
											<div class="col-6 col-md-2 col-lg-2 mt-1">
												<Select2 v-model="search.FK_ID_REGIONE.VALUE" :w="250" :api="'core/geo/regioni/select2'" :apiselected="'core/basic/element?className=Regione&ID=ID_REGIONE&DESCRIZIONE=NOME&select2=1'" :tabindex="17" :placeholder="'Regione'"></Select2>
											</div>
											<div class="col-12 col-md-2 col-lg-2 mt-1">
												<Select2 v-model="search.FK_ID_COMUNE.VALUE" :w="250" :api="'core/geo/comuni/select2'" :apiselected="'core/basic/element?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME&select2=1'" :tabindex="18" :placeholder="'Comune'"></Select2>
											</div> 
											<div class="col-6 col-md-2 col-lg-2 mt-1">
												<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Codice Fiscale" :tabindex="11" v-model="search.CODICE_FISCALE.VALUE" />
											</div> 
											<div class="col-6 col-md-2 col-lg-2 mt-1">
												<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Telefono" :tabindex="9" v-model="search.TELEFONO.VALUE" />
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				
			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead" style="min-height: calc(100vh - 392px);">
		               		<table class="table table-bordered table-hover table-striped table-togglable table-width"> 
			                    <thead class="sticky-top">
									<tr class="bg-secondary text-white">
										<th class="table-head-sm" style="width:2%;"> 
											<input id="chkAllUsers" @click.prevent="filters.selectAll('chkAllUsers',paginatedList.arr)" type="checkbox" class=""> 
										</th>
										<th class="table-head-sm" style="width:6%;">
											 # <ISort class="float-end" v-model="ordinamento" :campo="'ID_UTENTE'"></ISort>
											<br /><span class="float-end">Ord. </span>
										</th>
										<th class="table-head-sm text-center" style="width:4%;"> Img </th>
										<th class="table-head-sm" style="width:27%;">Nominativo <ISort class="float-end" v-model="ordinamento" :campo="'DESCRIZIONE'"></ISort><br />Contatti</th>
										<th class="table-head-sm" style="width:17%;">
											<span v-if="livello < 3">Ruolo /<br />Gruppo</span>
											<span v-else>Tipologia /<br />Nazionalità</span>
										</th>
										<th class="table-head-sm" style="width:17%;">Data di Nascita /<br />Residenza</th>
										<th class="table-head-sm" style="width:17%;">
											<div v-if="livello < 3">Accesso /<br />Livello</div>
											<div v-else>Ordini /<br />Fatturati</div>
										</th>
										<th class="table-head-sm text-center" style="width:5%;">Stato</th>
										<th class="table-head-sm text-center" style="width:5%;">Azioni</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="utente in paginatedList.arr" v-bind:key="utente.ID_UTENTE" :class="{ 'table-danger text-muted': utente.FLG_ELIMINATO == 1 }">
										<td class="td-class text-center">
											<span class="footable-toggle"></span>
											<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="utente.SELEZIONATO" class=""> 
										</td>
										<td class="td-class fs-sm">
											<span>{{utente.ID_UTENTE}}</span><br />
											<small class="badge bg-light badge-xs text-primary cursor-pointer float-end"> &nbsp; </small>
										</td>
										<td class="td-class text-center"> 
											<img v-if="utente.ID_UTENTE > 0 && utente.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('USERS',utente.URL_AVATAR)" class="rounded" style="width: 50px; height: 40px;" alt="" />
											<span v-if="utente.URL_AVATAR == 'placeholder.jpg'" class="btn-nophoto squared fs-sm" style="width: 50px; height: 40px !important; line-height: 10px; padding-top: 8px; font-size: 0.6rem !important;">No<br />Photo</span>
										</td>
										<td class="td-class fs-sm">
											<div>
												<i v-show="utente.NOTE != ''" class="ph-info fs-base lh-base align-top text-pink cursor-pointer me-1" style="margin-top: -1.5px;" title="Note personali" data-bs-toggle="tooltip" data-bs-placement="top" @click.prevent="showNote(utente)"></i>
												<span class="text-primary text-uppercase fw-bold cursor-pointer" @click.prevent="openOffCanvas();openSchedaVisualizzazioneUtente(utente)">{{utente.COGNOME}} {{utente.NOME}}</span>
											</div>
											<div>
												<span v-show="livello < 4" class="badge bg-light badge-xs text-dark rounded-0 me-2" style="border: 1px #dddddd solid;"><i class="far fa-user fa-fw"></i> {{utente.USERNAME}}</span>
												<span class="badge bg-light badge-xs text-dark rounded-0 me-1" style="border: 1px #dddddd solid;" data-bs-toggle="tooltip" data-bs-placement="top" :title="utente.EMAIL" v-bind:href="`mailto:${utente.EMAIL}`"><i class="fal fa-envelope fa-fw"></i> Email</span>
												<span class="badge bg-light badge-xs text-dark rounded-0 me-1" style="border: 1px #dddddd solid;" data-bs-toggle="tooltip" data-bs-placement="top" :title="utente.TELEFONO" v-bind:href="`tel:${utente.TELEFONO}`"><i class="fal fa-phone fa-fw"></i> Tel.</span>
											</div>																					
										</td>  
										<td class="td-class fs-sm">
											<div v-if="livello != 5">
												<span class="badge bg-light badge-xs text-dark rounded-0 me-1" style="border: 1px #dddddd solid;"><i class="far fa-square fa-fw" v-bind:style="getStileColore(utente)" data-bs-toggle="tooltip" data-bs-placement="top" :title="'Ruolo'"></i> {{utente.RUOLO}}</span><br/>
												<span>Gruppo</span>
											</div>
											<div v-if="livello == 5">
												<span class="badge bg-light badge-xs text-dark rounded-0 me-1" style="border: 1px #dddddd solid;"><i class="fal fa-tag fa-fw"></i> Privato </span><br/>
												<span><Flag :country="utente.FK_ID_NAZIONALITA" class="rounded me-2"></Flag> {{ utente.STATO_NAZIONALITA }}</span>
											</div>
										</td>
										<td class="td-class fs-sm">
											<span class="text-dark" data-bs-toggle="tooltip" data-bs-placement="top" title="Data di Nascita"><i class="fal fa-calendar-alt fa-fw me-1"></i>{{filters.formatDate(utente.DATA_NASCITA)}}</span><br />
											<span class="text-muted"><i class="fal fa-map-marker-alt fa-fw me-1"></i>{{utente.STATO_RESIDENZA}} - {{utente.REGIONE}} - {{utente.COMUNE}}</span>
										</td>
										<td class="td-class fs-sm">
											<div v-if="livello < 5"><i class="ph-check-circle fs-base lh-base align-top text-success me-1"></i> Ultimo accesso: <span class="text-primary">{{ filters.formatDateTime(utente.DATA_ACCESSO) }}</span></div>
											<div v-if="livello < 5"><i class="ph-clock fs-base lh-base align-top text-danger me-1"></i> Ultima Azione: <span class="text-primary">{{ filters.formatDateTime(utente.DATA_ULTIMA_AZIONE) }}</span></div>
											<div v-if="livello == 5"><i class="ph-check-circle fs-base lh-base align-top text-success me-1"></i> Fatturato {{ annoCorrente }}: <a href="#" @click.prevent="openOffCanvas();openSchedaVisualizzazioneUtente(utente,'ordini',annoCorrente)"> {{ utente.FATTURATO_ANNO_CORRENTE }} </a></div>
											<div v-if="livello == 5"><i class="ph-clock fs-base lh-base align-top text-danger me-1"></i> Fatturato {{ annoPrecedente }}: <a href="#" @click.prevent="openOffCanvas();openSchedaVisualizzazioneUtente(utente,'ordini', annoPrecedente)"> {{ utente.FATTURATO_ANNO_PREC }} </a></div>
										</td>
										<td class="td-class text-center">
											<ISwitch @toggle="updateStatoUtente(utente)" v-model="utente.STATO" :size="'sm'" :disabled="!canGestione(utente)" style="z-index: 0;"></ISwitch>
										</td>
										<td class="td-class text-center">
											<div class="dropdown" v-if="canGestione(utente)">
												<a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false">
													<i class="ph-list"></i>
												</a>
												<div class="dropdown-menu dropdown-menu-end">
													<div class="dropdown-header text-uppercase font-size-xs line-height-xs">Gestione</div>
													<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('UTENTE_UPDATE')" v-on:click="modificaUtente(utente)"><i class="fad fa-pencil fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica Utente</a>
													<div class="dropdown-divider"></div>
													<a href="#" class="dropdown-item" v-if="$root.isGod || utente.ID_UTENTE == $root.utente.ID_UTENTE" @click.prevent="resetPassword(utente)"><i class="fad fa-key fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Reset Password</a>
													<a href="#" class="dropdown-item" v-if="$root.isGod" @click.prevent="login(utente)"><i class="fad fa-cogs fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Login diretto</a>
													<a href="#" class="dropdown-item text-warning" v-if="$root.isGod && utente.ID_UTENTE != $root.utente.ID_UTENTE" @click.prevent="disconnettiUtente(utente)"><i class="fad fa-sign-out-alt fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Disconnetti utente</a>
													<div class="dropdown-header text-uppercase font-size-xs line-height-xs" v-if="$root.hasFunzionalita(azioneAdmin)">Admin</div>
													<a v-if="$root.hasFunzionalita(azioneAdmin) && livello == 5" href="#" class="dropdown-item" ><i class="fad fa-code-merge fa-fw me-2"></i><span class="text-muted me-1">|</span>Merge Utente</a>
													<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita(azioneAdmin) && $root.hasFunzionalita('UTENTE_DELETE') && utente.FLG_ELIMINATO != 1" @click.prevent="deleteUtente(utente)"><i class="fad fa-trash fa-lg fa-fw text-danger me-2"></i><span class="text-muted me-1">|</span>Elimina Utente</a>
													<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && utente.FLG_ELIMINATO == 1" @click.prevent="eliminaDefinitivamenteUtente(utente)"><i class="fad fa-trash fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Elimina definitivamente</a>
													<a href="#" class="dropdown-item text-success" v-if="$root.isGod && utente.FLG_ELIMINATO == 1" @click.prevent="ripristinaUtente(utente)"><i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span>Ripristina</a>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
		
		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2"><span v-if="livello == 5">CLIENTI</span><span v-else>UTENTI</span>: {{ paginatedList.count }}</span> 
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2" v-show="livello == 5">FATTURATO: {{ filters.formattaImporto(getTotali['FATTURATO']) }}</span>
                                </div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end pag-mobile">
			                        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
			                    </div>
			                </div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
		                            <option value="5">5</option>
		                            <option value="10">10</option>
		                            <option value="25">25</option>
		                            <option value="50">50</option>
		                            <option value="75">75</option>
		                            <option value="100">100</option>
		                            <option value="250">250</option>
		                            <option value="500">500</option>
		                        </select>
			            	</div>
			        	</div>
					</div>
				</div>
			</div>

			<div class="tab-pane fade" id="utenti-b">

				<div class="row">
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-users ph-2x text-primary me-3"></i>
								<div class="flex-fill text-end">
									<h4 class="mb-0">{{ getTotali.COUNT }}</h4>
									<span class="text-muted">Totale </span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-thumbs-up ph-2x text-success me-3"></i>

								<div class="flex-fill text-end">
									<h4 class="mb-0">{{ getTotali.UTENTI_CON_ORDINI }}</h4>
									<span class="text-muted">Utenti attivi</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-thumbs-down ph-2x text-danger me-3"></i>
								<div class="flex-fill text-end">
									<h4 class="mb-0">{{  getTotali.UTENTI_SENZA_ORDINI }}</h4>
									<span class="text-muted">Utenti 0 pratiche</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0">{{  getTotali.USER_KO }}</h4>
									<span class="text-muted">Utenti bannati</span>
								</div>
								<i class="ph-house-simple ph-2x text-danger ms-3"></i>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0">{{ filters.formattaImporto(getTotali.FATTURATO) }} </h4>
									<span class="text-muted">Tot. Fatturato {{ annoCorrente}} </span>
								</div>
								<i class="ph-sketch-logo ph-2x text-indigo ms-3"></i>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0">{{ filters.formattaImporto(getTotali.FATTURATO_PRECEDENTE) }}</h4>
									<span class="text-muted">Tot. Fatturato {{ annoPrecedente}}  </span>
								</div>
								<i class="ph-globe-hemisphere-east ph-2x text-purple ms-3"></i>
							</div>
						</div>
					</div>
				</div>

				<Statistiche :modalita="1" :ref="'statistiche'"></Statistiche>

			</div>

			<SchedaUtente :ref="'schedaUtente'" @updateGriglia="getUtenti();" @updateUtente ="getUtente"></SchedaUtente>

		</div>
	</div>	


	<!-- START MODALI -->
    <div class="offcanvas offcanvas-end offcanvas-size-xlg" id="panel_right" data-bs-backdrop="false" role="dialog" tabindex="-1">
		<div class="offcanvas-header bg-info text-white border-0" style="height: 3.95rem;">
			<h5 class="modal-title modal-title-width">
				<i class="ph-list icon-modal-size me-2"></i>Scheda Informativa
			</h5>  
			<div class="btn-group float-end" :tabindex="2" v-show="livello == 5">
				<a href="#" class="badge bg-indigo text-dark p-2 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Azioni Marketing</a>
				<div class="dropdown-menu dropdown-position dropdown-menu-end" data-popper-placement="bottom-start" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate3d(0px, 42px, 0px);">
					<a href="#" class="dropdown-item"><i class="fal fa-print fa-fw me-2"></i><span class="text-muted me-1">|</span>Stampa scheda </a>
					<a href="#" class="dropdown-item"><i class="fal fa-envelope fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia email </a>
					<a href="#" class="dropdown-item"><i class="fal fa-paper-plane fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia sms </a>
				</div>
			</div>
			<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="offcanvas">
				<i class="ph-x icon-x-size"></i>
			</button>
		</div>
		<div class="offcanvas-body p-2">

			<SchedaVisualizzazioneUtente :ref="'schedaVisualizzazioneUtente'" @modificaUtente="modificaUtente($event)"></SchedaVisualizzazioneUtente>

		</div>
        <div class="border-top p-1 bg-light">                                
			<button type="button" class="btn btn-link float-end" data-bs-dismiss="offcanvas">
				<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
			</button> 
        </div>  
	</div>	 

	<div class="modal fade" id="modalNote" role="dialog" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-info text-white border-0">
					<h5 class="modal-title">
						<i class="ph-list icon-modal-size me-2"></i><span class="me-2">{{levelName}}:</span>{{ utenteSelezionato.NOME }} {{ utenteSelezionato.COGNOME }}  
					</h5>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal">
						<i class="ph-x icon-x-size"></i>
					</button>
				</div>
				<div class="modal-body" style="height: 15rem;">

					<h6 class="fw-semibold mb-1">
						<i class="ph-info me-2"></i>Note Importanti:
					</h6>
					<hr />

					<div class="textarea rounded" v-html="utenteSelezionato.NOTE"></div>

				</div>
				<div class="modal-footer bg-light p-1">                                
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
				</div>
			</div>
		</div>
	</div> 
	    
	<div class="modal fade" id="modalPassword" role="dialog" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-info text-white border-0">
					<h5 class="modal-title">
						<i class="ph-list icon-modal-size me-2"></i><span class="me-2">{{levelName}}:</span>{{ utenteSelezionato.NOME }} {{ utenteSelezionato.COGNOME }} 
					</h5>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
                </div>
				<div class="modal-body" style="height: 17rem;">

					<h6 class="fw-semibold mb-1">
						<i class="ph-info me-2"></i>Reset Password:
					</h6>
					<hr />

					<div class="bootbox-body">
						
						<div class="row mb-3">
							<label class="col-md-4 col-form-label">Nuova password</label>
							<div class="col-md-8 mb-2">
								<div class="form-floating form-control-feedback-start">
									<div class="form-control-feedback-icon">
										<i class="ph-lock-key-open"></i>
									</div>
									<input autocomplete="off" type="password" class="form-control" placeholder="Nuova password" v-model="utenteSelezionato.PASSWORD">
									<label>Inserisci qui la nuova password</label>
								</div>
							</div>
							<label class="col-md-4 col-form-label">Conferma password</label>
							<div class="col-md-8">
								<div class="form-floating form-control-feedback-start">
									<div class="form-control-feedback-icon">
										<i class="ph-lock-key"></i>
									</div>
									<input autocomplete="off" type="password" class="form-control" placeholder="Conferma nuova password" v-model="utenteSelezionato.CONFERMA_PASSWORD">
									<label>Riscrivi per conferma la nuova password</label>
								</div>
							</div>
						</div>
							
					</div>

				</div>
				<div class="modal-footer bg-light p-1">                                
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
					<button type="button" class="btn btn-success float-end btn-sm" @click.prevent="doResetPassword()"><i class="far fa-plus-square fa-fw"></i> SALVA</button>                                   
				</div>
			</div>
		</div>
	</div> 

    <div class="modal fade" id="popUpLogAzioniUtente" role="dialog" tabindex="-1">
    	<div class="modal-dialog modal-lg">
            <div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0">
                    <div class="d-flex d-lg-none me-2">
                        <button type="button" class="navbar-toggler sidebar-mobile-component-toggle rounded-pill">
                            <i class="ph-arrow-down"></i>
                        </button>
                    </div>
                    <h6 class="modal-title">Logs dettagli Azioni - {{utenteSelezionato.USERNAME}}</h6>  
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
					<div class="row">
						<div class="col-md-4">
							<Datepicker autocomplete="off" class="bg-light" style="width:250px" v-model="dataCreazioneRange" @update:model-value="datePickerChangeHandler()"  range multi-calendars   :formats="{ input: 'dd/MM/yyyy' }" auto-apply  :partial-range="false" :tabindex="2" />
						</div>
						<div class="col-md-4">
							<button class="btn btn-light btn-sm" @click.prevent="aggiornaLogAzioni()">MOSTRA</button>
						</div>
						<div class="col-md-4"></div>
					</div>
					<hr class="hr-2" />
					<div class="tableFixHead tableFixHeadPopUp">
						<table class="table table-bordered table-hover table-striped table-togglable"> 
							<thead>
								<tr>
									<th class="table-head-sm" style="width:20%;"> Data </th>
									<th class="table-head-sm" style="">Api</th>
								<th class="table-head-sm" style="width:5.4%;">Azione</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="azione in arrayAzioniUtente" v-bind:key="azione">
									<td class="table-head-sm" style="">{{filters.formatDateTime(azione.time)}}</td>
									<td class="table-head-sm" style="">{{ azione.message }}</td>
									<td class="text-center">
										<div class="list-icons" :tabindex="26">
											<a href="#" class="list-icons-item" @click.prevent="apriDettaglioAzione(azione)"><i class="icon-menu9"></i></a>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--scroll kt-datatable--loaded" >
						<!-- 
						<Pagine v-model="searchArrayAzioniUtente.PAGINATION.PAGE_NUMBER" :numpagine="searchArrayAzioniUtente.PAGINATION.LENGTH"></Pagine>-->
					</div>
					
				</div>
				<div class="modal-footer bg-light p-1"> 
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal"><i class="fal fa-sign-out-alt fa-fw me-1"></i> CHIUDI</button>
				</div>
			</div>
		</div>
	</div>

	<!-- POPUP ESPORTAZIONE -->
	<PopUpEsportazione id="popUpEsportazioneUtenti" @esporta="esportaDati" />

    <div class="modal fade" id="popUpDettaglioLogAzioniUtente" role="dialog" tabindex="-1">
    	<div class="modal-dialog modal-lg">
            <div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0">
                    <div class="d-flex d-lg-none me-2">
                        <button type="button" class="navbar-toggler sidebar-mobile-component-toggle rounded-pill">
                            <i class="ph-arrow-down"></i>
                        </button>
                    </div>
                    <h6 class="modal-title">Logs dettagli Azioni - {{utenteSelezionato.USERNAME}}</h6>  
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
					<pre class="box_error" style="font-size:10px">
						{{ azioneSelezionata.context }}
					</pre>
				</div>
				<div class="modal-footer bg-light p-1">                                
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal"><i class="fal fa-sign-out-alt fa-fw me-1"></i> CHIUDI</button>
				</div>
			</div>
		</div>
	</div>

</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import ISwitch from '@/components/utils/ISwitch.vue'
import Select2 from '@/components/utils/Select2.vue'
import Select2Array from '@/components/utils/Select2Array.vue'
import ISort from '@/components/utils/ISort.vue'
import Flag from '@/components/utils/Flag.vue'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker' 
import SchedaUtente from '@/components/SchedaUtente.vue'
import SchedaVisualizzazioneUtente from '@/components/SchedaVisualizzazioneUtente.vue' 
import Statistiche from '@/components/Statistiche.vue'
import PopUpEsportazione from '@/components/common/PopUpEsportazione.vue'


export default {
    name: "Utenti",

    props: ['livello', 'idPersonaGiuridica'],	

    components:{
        Pagine,
        ISwitch,
        Select2,
        Select2Array,
		ISort,
		Flag,
		Datepicker,
        SchedaUtente,
		SchedaVisualizzazioneUtente,
		Statistiche,
		PopUpEsportazione

    },	 

    data: function () {
        return {   
            apiStartup:'core/utente/lista',
            filters:global.filters,
            GLOBAL_IMAGES_PATH:'',
			anno:new Date().getFullYear(),
            livelloMaxFiltroSocieta: 2,
            arrayUtenti: new Array(),
            utenteSelezionato:{personaFisica:{}},
            utenteCorrente:{},
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
				ANNO_ORDINE:{TYPE:'COMBO',VALUE: new Date().getFullYear()},
                ID_UTENTE:{TYPE:'TEXT',VALUE:''},
				DENOMINAZIONE : {TYPE:'TEXT',VALUE:''},
                EMAIL:{TYPE:'TEXT',VALUE:''},
                NOME:{TYPE:'TEXT',VALUE:''},
                SESSO:{TYPE:'TEXT',VALUE:''},
                COGNOME:{TYPE:'TEXT',VALUE:''},
				CODICE_FISCALE:{TYPE:'TEXT',VALUE:''},
				DATA_CREAZIONE:{TYPE:'DATE_RANGE',VALUE_FROM:'',VALUE_TO:''},
				TELEFONO:{TYPE:'TEXT',VALUE:''},
                FK_ID_RUOLO:{TYPE:'COMBO',VALUE:''},
				FK_ID_POSIZIONE:{TYPE:'COMBO',VALUE:''},
				FK_ID_TIPOLOGIA:{TYPE:'COMBO',VALUE:''},				
				FK_ID_COMUNE:{TYPE:'COMBO',VALUE:''},	
				FK_ID_REGIONE:{TYPE:'COMBO',VALUE:''},	
				FK_ID_NAZIONALITA:{TYPE:'COMBO',VALUE:''},	
                STATO:{TYPE:'COMBO',VALUE:'1'},
				FLG_ELIMINATO:{TYPE:'COMBO',VALUE:'0'},

            },
		    ordinamento:'',
			esportazioneTipo:'',
			modulo:0,
			dataCreazioneRange:{},
			selectedMenuItem:{},
			dataCreazioneRangeFatt:{},
			azioneSelezionata : {},
			arrayCampiPopUpUtente : new Array(),
			arrayAzioniUtente : new Array(),
			arrayOpzioniAll : new Array(),
			arrayPosizioni: new Array(),
			arrayTipologie : new Array(),
			arrayRuoli : new Array(),
			statsUtenti:{},
			searchStatisticheOrdini:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
				FK_ID_REGIONE:{TYPE:'COMBO',VALUE:''},
				FK_ID_PROVINCIA:{TYPE:'COMBO',VALUE:''},
				FK_ID_COMUNE:{TYPE:'COMBO',VALUE:''},				
            },
			arrayStatisticheOrdiniFatt : new Array(),
			searchStatisticheOrdiniFatt:{
				PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
				FK_ID_REGIONE:{TYPE:'COMBO',VALUE:''},
				FK_ID_PROVINCIA:{TYPE:'COMBO',VALUE:''},
				FK_ID_COMUNE:{TYPE:'COMBO',VALUE:''},
				DATA_CREAZIONE:{TYPE:'DATE_RANGE',VALUE_FROM:'',VALUE_TO:''},	
			}
			
        }
    },

    methods: {

        getUtenti : function() {
            const params = {
                FK_ID_LIVELLO: this.livello,
                ANNO: this.search.ANNO_ORDINE.VALUE
            };
            if (this.idPersonaGiuridica) {
                params.FK_ID_PERSONA_GIURIDICA = this.idPersonaGiuridica;
            }
            utils.get(this.apiStartup, params, (response) => {
                this.arrayUtenti = response.data;
				utils.ajax('shared/notifiche/associaTipologieUtenti', {}, (response) => {
					if (response.esito == 0) {
					}
				});
            });
        }, 

		getUtente : function(idUtente){
			this.utenteSelezionato.ID_UTENTE = idUtente;
			this.$refs.schedaVisualizzazioneUtente.openSchedaVisualizzazioneUtente(this.utenteSelezionato);
		},

        nuovoUtente : function(){
            this.utenteSelezionato = {ID_UTENTE:0,persona:{SESSO:""},FK_ID_LIVELLO:this.livello,FK_ID_ENTE:this.$root.idEnteCorrente};
            if (this.idPersonaGiuridica) {
                this.utenteSelezionato.FK_ID_PERSONA_GIURIDICA = this.idPersonaGiuridica;
            }
            this.$refs.schedaUtente.openSchedaUtente(this.utenteSelezionato);
        }, 

		modificaUtente : function(utente){
			// Chiudi l'offcanvas se aperto
			var myOffcanvas = document.getElementById('panel_right');
			if (myOffcanvas) {
				var bsOffcanvas = bootstrap.Offcanvas.getInstance(myOffcanvas);
				if (bsOffcanvas) {
					bsOffcanvas.hide();
				}
			}
			// Apri la modal di modifica
			this.progettoSelezionato = utils.clone(utente);
			this.$refs.schedaUtente.openSchedaUtente(this.progettoSelezionato);
		}, 

        updateStatoUtente : function(utente){
            setTimeout(() => {
                utils.put('core/utente/stato/update',utente, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio);
                    }  
                }); 
            },250);
        },

		deleteUtente(utente) {
			utils.alert.confirm('Eliminare ' + utente.NOME + ' ' + utente.COGNOME + '?', () => {
				utils.delete('theb/utente/delete', { ID_UTENTE: utente.ID_UTENTE }, (r) => {
					if (r.esito == 0) { this.getUtenti(); utils.alert.success(r.messaggio); }
				});
			}, this.$root);
		},

		eliminaDefinitivamenteUtente(utente) {
			utils.alert.confirm('Eliminare definitivamente ' + utente.NOME + ' ' + utente.COGNOME + '?', () => {
				utils.delete('theb/utente/harddelete', { ID_UTENTE: utente.ID_UTENTE }, (r) => {
					if (r.esito == 0) { this.getUtenti(); utils.alert.success(r.messaggio); }
				});
			}, this.$root);
		},

		ripristinaUtente(utente) {
			utils.put('theb/utente/ripristina', { ID_UTENTE: utente.ID_UTENTE }, (r) => {
				if (r.esito == 0) { this.getUtenti(); utils.alert.success('Utente ripristinato.'); }
			});
		},

		attivaSelezionati() {
			var sel = utils.array.select(this.arrayUtenti, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessun utente selezionato.'); return; }
			utils.alert.confirm('Attivare ' + sel.length + ' utenti?', () => {
				utils.put('theb/utente/attiva-bulk', { IDS: sel.map(u => u.ID_UTENTE) }, (r) => {
					if (r.esito == 0) { this.getUtenti(); utils.alert.success('Utenti attivati con successo.'); }
				});
			}, this.$root);
		},

		disattivaSelezionati() {
			var sel = utils.array.select(this.arrayUtenti, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessun utente selezionato.'); return; }
			utils.alert.confirm('Disattivare ' + sel.length + ' utenti?', () => {
				utils.put('theb/utente/disattiva-bulk', { IDS: sel.map(u => u.ID_UTENTE) }, (r) => {
					if (r.esito == 0) { this.getUtenti(); utils.alert.success('Utenti disattivati con successo.'); }
				});
			}, this.$root);
		},

		eliminaSelezionati() {
			var sel = utils.array.select(this.arrayUtenti, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessun utente selezionato.'); return; }
			utils.alert.confirm('Eliminare ' + sel.length + ' utenti selezionati?', () => {
				utils.delete('theb/utente/delete-bulk', { IDS: sel.map(u => u.ID_UTENTE) }, (r) => {
					if (r.esito == 0) { this.getUtenti(); utils.alert.success('Utenti eliminati con successo.'); }
				});
			}, this.$root);
		},

        resetPassword : function(utente){
            this.utenteSelezionato = utils.clone(utente);
			this.filters.openPopUp("modalPassword"); 
        }, 

        doResetPassword : function(){
			this.filters.closePopUp("modalPassword");
            utils.put('core/admin/utente/password/reset',this.utenteSelezionato, (response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                }  
            }); 
        },
        
        showNote : function(utente){
            this.utenteSelezionato = utils.clone(utente);
			this.filters.openPopUp("modalNote"); 
        },	

		login : function(utente){
			utils.ajax('core/utente/login',{ID_UTENTE:utente.ID_UTENTE}, (response) => {
				if (response.esito == 0){
					window.location.reload();
				}
			});
		},

		disconnettiUtente : function(utente){
			utils.alert.confirm("Disconnettere " + utente.USERNAME + "? Dovrà rifare la login.", () => {
				utils.sessioneUtente(this, utente, 'LOGOUT');
			}, this);
		},

		getTipologia: function(utente){
			if(this.ID_UTENTE = 0){
				return 'Privato';
			} 
			else {
				return 'Aziendale';
			} 
		},

		logAzioni : function(utente){	
			this.utenteSelezionato = utils.clone(utente);
			this.filters.openPopUp("popUpLogAzioniUtente"); 			
		},

		aggiornaLogAzioni : function(){
			utils.ajax('core/utente/azioni',{ID_UTENTE:this.utenteSelezionato.ID_UTENTE,DATA_DA:this.searchAzioni.DATA_CREAZIONE.VALUE_FROM,DATA_A:this.searchAzioni.DATA_CREAZIONE.VALUE_TO}, (response) => {
				this.arrayAzioniUtente = response.data;
			});			
		},	

		apriDettaglioAzione : function(azione){
			this.azioneSelezionata = azione;
			this.filters.openPopUp("popUpDettaglioLogAzioniUtente");	
		},	

		getStileColore : function(utente){
			return {color:utente.COLORE};
		},	

		checkShowRuolo : function(ruolo){			
			if (this.livello != 5){
				if (ruolo.CUSTOM_1 == "" || ruolo.CUSTOM_1 == this.livello){
					return true;
				}
			}
			else{
				if (ruolo.CUSTOM_1 == this.livello){
					return true;
				}
			}
			return false;
		}, 

		openOffCanvas : function(){
			var myOffcanvas = document.getElementById('panel_right')
			var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas)
			bsOffcanvas.show();
		},

		openSchedaVisualizzazioneUtente : function(utente,tab = "",opzioni = null){
			this.utenteSelezionato = utils.clone(utente);	
			this.$refs.schedaVisualizzazioneUtente.openSchedaVisualizzazioneUtente(utente,tab,opzioni);
		},

		datePickerChangeHandler : function(){
			this.search.DATA_CREAZIONE = {TYPE:'DATE_RANGE',VALUE_FROM:'',VALUE_TO:''};
			if (this.dataCreazioneRange != null && this.dataCreazioneRange.length > 0){
				this.search.DATA_CREAZIONE = {TYPE:'DATE_RANGE',VALUE_FROM:this.filters.formatDate(this.dataCreazioneRange[0]),VALUE_TO:this.filters.formatDate(this.dataCreazioneRange[1])};
			}
		},

		dataCreazioneRangeChangeHandler : function(){
            this.searchStatisticheOrdiniFatt.DATA_CREAZIONE = {TYPE:'DATE_RANGE',VALUE_FROM:'',VALUE_TO:''};
            if (this.dataCreazioneRangeFatt != null && this.dataCreazioneRangeFatt.length > 0){
                this.searchStatisticheOrdiniFatt.DATA_CREAZIONE = {TYPE:'DATE_RANGE',VALUE_FROM:this.filters.formatDate(this.dataCreazioneRangeFatt[0]),VALUE_TO:this.filters.formatDate(this.dataCreazioneRangeFatt[1])};
            }
        },

		statisticheStartup : function(){
			this.$refs.statistiche.statisticheStartup();
		},

		canGestione : function(utente){
			if(this.livello != 2) return true;
			return this.$root.hasFunzionalita(this.azioneAdmin) || utente.ID_UTENTE == this.$root.utente.ID_UTENTE;
		},

		apriEsportazione: function(tipo) {
			this.esportazioneTipo = tipo;
			this.filters.openPopUp('popUpEsportazioneUtenti');
		},

		esportaDati: function(formato) {
			var nomeFile = this.livello == 5 ? 'utenti' : 'admin';
			utils.esportaTabella({
				tipo:          this.esportazioneTipo,
				formato:       formato,
				arrayCompleto: this.arrayUtenti,
				arrayPagina:   this.paginatedList.arr,
				idField:       'ID_UTENTE',
				modulo:        'utenti',
				nomeFile:      nomeFile
			});
		},


        
    },	

    computed: {
		// il flag che apre la gestione di tutti gli utenti, diverso per famiglia di modulo
		azioneAdmin(){
			return (this.livello == 1 || this.livello == 2) ? 'AMMINISTRATORI_ADMIN' : 'CLIENTI_ADMIN';
		},

        paginatedList(){
            var arr = utils.inGrid(this.arrayUtenti,this.search, this.ordinamento);
            return arr;
        },	 

		paginatedListFatt(){
            var arr = utils.inGrid(this.arrayStatisticheOrdiniFatt,this.searchStatisticheOrdiniFatt);
            return arr;
        },
		
        levelName(){
            switch (this.livello){
                case 1:		return 'Autori';
                case 2:		return 'Amministratori';
                case 3:		return 'Fornitori';
                case 4:		return 'Agenzie';
                default:	return 'Clienti';
            }
			return "";
        },	  

        iconLevel(){
            switch (this.livello){
                case 1:		return 'fa-key';
                case 2:		return 'fa-user';
                case 4:		return 'fa-plane';
                default:	return 'fal fa-box';
            }
			return "";
        }, 

		getTotali(){
			var fatturato = 0;
			var fatturatoT1 = 0;
			var attive = 0;
            var inattive = 0; 
			var arrayUtenti = utils.filter(this.arrayUtenti,this.search);
			for (var i = 0; i < arrayUtenti.length; i++) {
				fatturato += parseFloat(arrayUtenti[i].FATTURATO_ANNO_CORRENTE);
				fatturatoT1 += parseFloat(arrayUtenti[i].FATTURATO_ANNO_PREC);
				if (arrayUtenti[i].STATO == 1) {
					attive++;
				} else {
					inattive++;
				}
            }
			var entitaConOrdini = 0;
			if (this.$refs.statistiche != undefined && this.$refs.statistiche != null ){
				entitaConOrdini = this.$refs.statistiche.statsUtenti.TOT_UTENTI_CON_ORDINI;
			}
            return {
                COUNT:this.arrayUtenti.length,
				UTENTI_CON_ORDINI:entitaConOrdini,
				UTENTI_SENZA_ORDINI:parseFloat(this.arrayUtenti.length) - parseFloat(entitaConOrdini),
				FATTURATO:fatturato,
				FATTURATO_PRECEDENTE:fatturatoT1,
				USER_OK:attive,
				USER_KO:inattive,
            }
        },

		annoCorrente : function(){
			return new Date().getFullYear();
		},

		annoPrecedente : function(){
			return new Date().getFullYear() - 1;
		}

    },

	watch:{
	
	},

    created: function () {
        global.utils.BASE_API = process.env.VUE_APP_API_URL;
        this.GLOBAL_IMAGES_PATH = process.env.VUE_APP_GLOBAL_IMAGES_PATH;
        this.utenteCorrente = utils.clone(this.$root.utente);
		utils.get("core/utente/startup",{ID_LIVELLO:this.livello}, (response) => {
			this.arrayTipologie = utils.array.select(response.data,"FK_ID_TIPOLOGICA",this.$root.COSTANTI.TIPOLOGICA_CLIENT_TIPOLOGIE);
			this.arrayPosizioni = utils.array.select(response.data,"FK_ID_TIPOLOGICA",this.$root.COSTANTI.TIPOLOGICA_CLIENT_POSIZIONI);
			this.getUtenti();
		}); 

		switch (this.livello){
			case 2:
				this.modulo = 21;
				break;
			case 5:
				this.modulo = 22;
				break;
		}		        
        
    },

}
</script>

<style scoped>
	.grafico { min-height: 451px; }	
</style>
